<template>
  <div class="container" ref="containerRef">
    <div class="no-more-msg" v-if="lastId == '' || lastId == 0"><span class="msg-span">暂无更多记录</span></div>
    <!-- 最外层的for循环 -->
    <!-- 由于内容存在图片, 所以如果key值不是唯一(如下标), 则每次添加内容都要重渲染, 图片要重新请求; 但是如果key唯一, 则之前的图片不会重新请求 -->
    <div v-for="item in chatArr" :key="item.key" class="each-row">
      <div class="message-date">{{ item.date }}</div>
      <template v-for="(subItem, subIndex) in item.value" :key="subIndex">
        <div v-if="subItem.send_source == 1" class="kefu-name">{{ subItem.user_name }} &nbsp; {{ subItem.send_time }}</div>
        <div v-else class="custom-name">{{ subItem.kefu_name }} &nbsp; {{ subItem.send_time }}</div>
        <div v-if="subItem.type == 1 || subItem.type == 3" class="row-div part-1-3" v-html="subItem.content"></div>
        <div v-else-if="subItem.type == 2" class="part-2">{{ subItem.content.title }} -- 预计到手价￥ {{ subItem.content.share_price }}</div>
        <template v-else-if="subItem.type == 4">
          <div v-if="subItem.isCommon" class="row-div part-4-if" v-html="subItem.content"></div>
          <div v-else class="part-4-else">
            <div class="user-goods-title">{{ subItem.content.top }}</div>
            <div class="user-goods-info">
              <div class="user-goods-info-title">{{ subItem.content.title }} &nbsp; {{ subItem.content.state_type_text }}</div>
              <div class="user-goods-info-price" v-if="!isNull(subItem.content.price) && !isNull(subItem.content.share_price)">
                ￥{{ subItem.content.share_price }}
              </div>
            </div>
            <template v-if="!isNull(subItem.content.ship_info) && !isNull(subItem.content.ship_info.ship)">
              <div>姓名：{{ subItem.content.ship_info.realname }}</div>
              <div>电话：{{ subItem.content.ship_info.mobile }}</div>
              <div>地址：{{ subItem.content.ship_info.address }}</div>
              <div>物流：{{ subItem.content.ship_info.ship }}</div>
            </template>
          </div>
        </template>
        <div v-else-if="subItem.type == 5" class="part-5">
          {{ subItem.contentForType5 }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EhfChatHistory',
  }
</script>

<script setup>
  import { toRefs, ref, reactive, onBeforeUnmount, onUpdated } from 'vue'
  import { message } from 'ant-design-vue'
  import { nanoid } from 'nanoid'
  import { getChatHistory as getChatHistoryAPI } from '@/api/wxserver/index.js'
  import { chatHistoryReplace, isNull, imgAllLoaded } from '@/utils/index.js'

  const props = defineProps({
    wx_uid: {
      // 查询的用户wx_uid
      type: String,
      default() {
        return ''
      },
    },
  })

  const { wx_uid } = toRefs(props)
  const chatArr = ref([]) // 聊天数组
  const lastId = ref('0') // 相当于page(页数)
  const pageSize = ref(20) // 每页显示
  const isAjaxing = ref(false) // 是否正在请求
  const containerRef = ref(null) // Dom ref
  const isInitialScroll = ref(true) // 是否是setup第一次调用
  const scrollObj = reactive({
    lastDistanceBetweenScrollBarAndBottom: 0, // 在翻页(上翻)之前, 记录滚动条离底部的距离
    isNeedScroll: false, // 是否需要更新滚动条
  })

  // 获取了解记录
  function getChatHistory(isFromScoll) {
    if (wx_uid.value == '') {
      return
    }
    if (isAjaxing.value) {
      return
    }
    isAjaxing.value = true
    const containerEl = containerRef.value
    // 计算此时的滚动条离底部的位置
    if (isFromScoll) {
      scrollObj.lastDistanceBetweenScrollBarAndBottom = containerEl.scrollHeight - containerEl.scrollTop
    }
    let params = {
      userid: wx_uid.value,
      last_id: lastId.value,
      pagesize: pageSize.value,
    }
    getChatHistoryAPI(params)
      .then((ret) => {
        let tempArr = []
        if (ret.code == 0 && ret.data && ret.data.count > 0) {
          // 对象
          for (let tempIndex in ret.data.list) {
            let tempValue = ret.data.list[tempIndex]
            // 这个内容预处理也是参照admin的
            tempValue.forEach((tempItem) => {
              if (tempItem.type == 1 || tempItem.type == 3) {
                tempItem.content = chatHistoryReplace(tempItem.content)
              } else if (tempItem.type == 2) {
                tempItem.content = JSON.parse(tempItem.content)
              } else if (tempItem.type == 4) {
                let tempContent = JSON.parse(tempItem.content)
                if (tempContent.type == 'common') {
                  tempItem.content = tempContent.top
                  tempItem.isCommon = true // 该属性额外加上去
                } else {
                  tempItem.isCommon = false
                  let tempOrderState = ''
                  if (tempContent.state_type) {
                    tempOrderState = '【' + tempContent.state_type + '】'
                  } else {
                    tempOrderState = ''
                  }
                  tempContent.state_type_text = tempOrderState // 暂时不考虑富文本结构
                  tempItem.content = tempContent
                }
              } else if (tempItem.type == 5) {
                let tempContent = JSON.parse(tempItem.content)
                tempItem.contentForType5 = tempContent.title + '【' + tempContent.state + '】' // 该属性额外加上去
              }
            })
            tempArr.push({
              date: tempIndex,
              value: tempValue,
              key: nanoid(), // 生成主键
            })
          }
          if (ret.data.count == pageSize.value && ret.data.last_id != '') {
            lastId.value = ret.data.last_id
          } else {
            lastId.value = ''
          }
        }
        if (tempArr.length > 0) {
          chatArr.value = tempArr.concat(chatArr.value)
          if (isFromScoll) {
            ctrlScrollListener(false)
            scrollObj.isNeedScroll = true
          }
        }
      })
      .catch((err) => {
        console.error('获取近15天聊天记录失败', err)
        message.error('获取近15天聊天记录失败')
      })
      .finally(() => {
        isAjaxing.value = false
      })
  }

  // 控制滚动监听
  const ctrlScrollListener = (state) => {
    const containerEl = containerRef.value
    if (state == true) {
      if (containerEl) {
        containerEl.addEventListener('scroll', scrollListener, false)
      }
    } else {
      if (containerEl) {
        containerEl.removeEventListener('scroll', scrollListener, false)
      }
    }
  }

  // 滚动加载
  const scrollListener = () => {
    const containerEl = containerRef.value
    const scrollTop = containerEl.scrollTop
    if (scrollTop < 100 && lastId.value != '' && !isAjaxing.value) {
      getChatHistory(true)
    }
  }

  onUpdated(() => {
    const containerEl = containerRef.value
    if (isInitialScroll.value) {
      // 之所以要在用个定时器, 是因为图片加载需要点时间, 不然有可能先滑了, 图片才加载完
      setTimeout(() => {
        containerEl.scrollTo(0, containerEl.scrollHeight)
        isInitialScroll.value = false
        ctrlScrollListener(true)
      }, 100)
    }

    if (scrollObj.isNeedScroll && containerEl) {
      imgAllLoaded(containerEl.querySelectorAll('img')).then(() => {
        // 回到上一次位置
        let containerElNewHeight = containerEl.scrollHeight
        containerEl.scrollTo(0, containerElNewHeight - scrollObj.lastDistanceBetweenScrollBarAndBottom)
        setTimeout(() => {
          ctrlScrollListener(true)
        }, 50)
        scrollObj.isNeedScroll = false
      })
    }
  })

  onBeforeUnmount(() => {
    // 组件卸载前清除滚动监听
    ctrlScrollListener(false)
  })

  // 初始化
  getChatHistory()
</script>

<style lang="scss" scoped>
  .container {
    height: 100%;
    overflow: scroll;

    .no-more-msg {
      text-align: center;
      margin-bottom: 10px;
      .msg-span {
        padding: 5px 15px;
        border-radius: 3px;
        background-color: #e2e2e2;
      }
    }

    .each-row > div {
      margin-bottom: 5px;
    }

    .message-date {
      text-align: center;
    }

    .kefu-name {
      color: #40a9ff;
    }

    .custom-name {
      color: #999;
    }
    .row-div {
      ::v-deep(img) {
        width: 50%;
        display: block;
      }
    }
    .user-goods-info {
      display: flex;
      align-items: center;
    }
  }
</style>
